export { default as translations } from './translations.json';

/**
 * Get admin badges from listing or user metadata.
 * @param {Object|null} entity — listing or user
 * @returns {Object[]}
 */
export const getAdminBadges = (entity) =>
  entity?.attributes?.metadata?.adminBadges || [];

/**
 * Check if entity has a specific admin badge.
 * @param {Object|null} entity
 * @param {string} badgeId
 * @returns {boolean}
 */
export const hasBadge = (entity, badgeId) =>
  getAdminBadges(entity).some(b => b.id === badgeId);
